import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "identifier-app",
  "use": "identifier-app-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"identifier-app\"><path d=\"M3 6h2v12H3zM7 6h3v12H7zM12 6h1v12h-1zM20 6h1v12h-1zM15 6h3v12h-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol